export const BrochurePackagingOptions = [20, 40, 60, 80, 100, 150, 200, 300];
